module.exports = __webpack_public_path__ + "img/playlist.5fb07bb4.svg";